export const HEADER_Y_AXIS_PADDING = 20;
